import { render, staticRenderFns } from "./aboutUs.vue?vue&type=template&id=3a7ceefa&scoped=true"
import script from "./aboutUs.vue?vue&type=script&lang=js"
export * from "./aboutUs.vue?vue&type=script&lang=js"
import style0 from "./aboutUs.vue?vue&type=style&index=0&id=3a7ceefa&prod&lang=less&scoped=true"
import style1 from "./aboutUs.vue?vue&type=style&index=1&id=3a7ceefa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a7ceefa",
  null
  
)

export default component.exports